import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import axios from "axios";

export const fetchGallery = createAsyncThunk(
  "gallery/fetchGallery",
  async (platform = "Website", { getState, rejectWithValue }) => {
    const state = getState().gallery.galleriesByPlatform?.[platform];

    // Prevent refetching if already fetched for that platform
    if (state && state.length > 0) {
      return { platform, data: state };
    }

    try {
      const response = await axios.get(`https://moga-dev.com/api/galleries/0?platform=${platform}`);

      if (response.data?.data) {
        return { platform, data: response.data.data };
      } else {
        return rejectWithValue("Invalid response format");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch gallery");
    }
  }
);


const gallerySlice = createSlice({
  name: "gallery",
  initialState: {
    galleriesByPlatform: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGallery.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGallery.fulfilled, (state, action) => {
        const { platform, data } = action.payload;
        state.loading = false;
        state.galleriesByPlatform[platform] = data;
      })
      .addCase(fetchGallery.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const selectGalleryByPlatform = (state, platform) =>
  state.gallery.galleriesByPlatform?.[platform] || [];
export const selectGalleryLoading = (state) => state.gallery.loading;
export const selectGalleryError = (state) => state.gallery.error;
export default gallerySlice.reducer;
